import { createContext, useContext } from "react";

import type {
  UiLanguage,
  UiMessageKey,
  UiMessageValues,
} from "./uiMessages";

export type UiLanguageContextValue = {
  language: UiLanguage;
  setLanguage: (language: UiLanguage) => void;
  text: (key: UiMessageKey, values?: UiMessageValues) => string;
};

export const UiLanguageContext = createContext<UiLanguageContextValue | null>(null);

export function useUiLanguage(): UiLanguageContextValue {
  const value = useContext(UiLanguageContext);
  if (value === null) {
    throw new Error("useUiLanguage must be used inside UiLanguageProvider");
  }
  return value;
}
